import Dotdotdot from 'react-dotdotdot'
import { Grid } from '@mui/material'
import { muiTheme, Text } from '@pbt/pbt-ui-components'

import BusinessShareIcon from '~/components/common/icons/BusinessShareIcon'

const ConversationSubjectCell = ({
  title,
  businessId,
  isSystemMessage,
}: {
  businessId?: string
  isSystemMessage?: boolean
  title: string
}) => {
  const color = isSystemMessage ? muiTheme.colors.grayGray2 : 'inherit'

  return (
    <Grid container item alignItems="center" wrap="nowrap">
      <Dotdotdot clamp={1}>
        <Text style={{ color }}>{title}</Text>
      </Dotdotdot>
      {businessId && (
        <BusinessShareIcon businessIds={[businessId]} noMargin={!title} />
      )}
    </Grid>
  )
}

export default ConversationSubjectCell
